module.exports = __webpack_public_path__ + "static/media/lion-owl.4aa67291.gif";